;(function () {
	// Shopify can include this asset for more than one section on the same page.
	if (window.mottoSlideshowLifecycle) return;
	window.mottoSlideshowLifecycle = true;

	const sections = new Map();
	const isLive = (section, state) => state.active && section.isConnected;
	const schedule = (section, state, callback, delay) => {
		const timer = setTimeout(() => {
			state.timers.delete(timer);
			if (isLive(section, state)) callback();
		}, delay);
		state.timers.add(timer);
	};
	
	const animateLines = (section, state, lines, delay=0) => {
		lines.forEach((line, i) => {
			line.classList.add('animated');
			Array.from(line.children).forEach((element) => {
				element.style.animationDelay = `${delay + (i * 0.25)}s`;
				
				schedule(section, state, () => {
					line.style.overflow = 'visible';
				}, delay*1000 + (i * 250) + 600);
			});
		});
	};

	const headingAnimation = (section, state) => {
		const slideshowTexts = section.querySelectorAll('.slideshow-slide__text--animation');
		const headings = section.querySelectorAll('.js-split-text');
		if (!slideshowTexts.length) return;
		state.headings = headings;

		const splitHeadings = () => {
			if (!headings.length) return;
			// This bundled SplitType version loses its saved HTML on instance re-split.
			if (state.split) state.split.revert();
			state.split = new SplitType(headings);
			headings.forEach((heading) => heading.classList.add('visible'));
		};

		const textObserver = new IntersectionObserver(
			(entries) => {
				if (!isLive(section, state)) return;
				entries.forEach((entry) => {
					const lines = entry.target.querySelectorAll('.js-split-text .line');
					if (entry.isIntersecting) {
						let speed = Number(entry.target.closest('.slideshow').dataset.speed);
						let speedFade = speed;
						if (lines) {
							speedFade = speed*1000 + (lines.length)*250 + 100;
							animateLines(section, state, lines, speed);
						}
						schedule(section, state, () => {
							entry.target.querySelectorAll('.js-fade').forEach(item => {
								item.classList.add('visible');
							})
						}, (speedFade + 100));
					}
					else {
						lines.forEach((line, i) => {
							line.classList.remove('animated');
							line.style.overflow = 'hidden';
						})
						entry.target.querySelectorAll('.js-fade').forEach(item => {
							item.classList.remove('visible');
						})
					}
				});
			},
			{
				rootMargin: "0px 0px 0px 0px"
			},
		);
		state.observers.push(textObserver);
		
		const resizeObserver = new ResizeObserver((entries) => {
			if (!isLive(section, state)) return;
			entries.forEach((entry) => {
				splitHeadings();
				const lines = entry.target.querySelectorAll('.js-split-text .line');
				if (lines.length) {
					animateLines(section, state, lines);
				}
				slideshowTexts.forEach((text) => {
					textObserver.observe(text);
				});
			});
		});

		state.observers.push(resizeObserver);
		splitHeadings();
		slideshowTexts.forEach((text) => {
			textObserver.observe(text);
			resizeObserver.observe(text);
		});
	};

	const slideshow = (section, state) => {
		$(section).each(function () {
			let zIndex;
			$(this).addClass('slider_started')
			const id = $(this).attr('id')
			const box = $(this).find('.slideshow')
			const autoplay = box.data('autoplay')
			const stopAutoplay = box.data('stop-autoplay')
			const delay = box.data('delay') * 1000
			const speed = box.data('speed') * 1000
			const effect = box.data('effect') == "custom" ? "fade": box.data('effect')
			let autoplayParm;
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
						waitForTransition: true
					},
				}
			} else {
				autoplayParm = {}
			}
			let swiperParms = {
				parallax: box.data('parallax'),
				effect: effect,
				virtualTranslate: effect == "custom",
				watchSlidesProgress: true,
				speed: speed,
				loop: false,
				centeredSlides: false,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				fadeEffect: { 
					crossFade: true 
				},
				creativeEffect: {
					prev: {
						shadow: false,
						translate: [0, 0, -400],
					},
					next: {
						translate: ['100%', 0, 0],
					},
				},
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: false,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: 'true',
					type: 'bullets',
				},
				...autoplayParm,
				on: {
					init: function () {
						//Fix for first slide
						if (box.data('effect') == "custom") {
							const firstSlide = this.slides[0];
							if (firstSlide.classList.contains('swiper-slide-active')) {
								firstSlide.classList.add('no-animation');
							}
						}
					},
				}
			}
			zIndex = $(this).find('.slideshow-swiper__slide').length;
			const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms)
			state.swiper = swiper;
			const onSwiper = (event, callback) => {
				const handler = function (...args) {
					if (isLive(section, state)) callback.apply(this, args);
				};
				swiper.on(event, handler);
				state.swiperListeners.push([event, handler]);
			};

			//Fix pause on mouse enter for custom effect
			const swiperContainer = swiper.el.querySelector('.swiper-wrapper');
			if (box.data('effect') == "custom" && autoplay && stopAutoplay) {
				const stop = () => { if (isLive(section, state)) swiper.autoplay.stop(); };
				const start = () => { if (isLive(section, state)) swiper.autoplay.start(); };
				swiperContainer.addEventListener('mouseenter', stop);
				swiperContainer.addEventListener('mouseleave', start);
				state.listeners.push([swiperContainer, 'mouseenter', stop], [swiperContainer, 'mouseleave', start]);
			}
					
			onSwiper('transitionStart', function () {
				if (box.data('effect') == "custom") {
					zIndex = zIndex + 1;
					this.slides[this.activeIndex].style.setProperty("z-index", `${zIndex}`);
				}
			})

			onSwiper('transitionEnd', function () {
				//Remove text animation for other slides
				this.slides.forEach((slide,i) => {
					if (i != this.activeIndex) {
						const headingSlide = slide.querySelector('.js-split-text');
						if (headingSlide) {
							const linesSlide = headingSlide.querySelectorAll('.line');
							linesSlide.forEach(line => {
								line.classList.remove('animated');
								line.style.overflow = 'hidden';
							})
						}
						slide.querySelectorAll('.js-fade').forEach(item => {
							item.classList.remove('visible');
						})
					}
				})
			})
			
			onSwiper('beforeTransitionStart', function () {
				colorScheme(this)
			})

			onSwiper('slideChange', function () {
				box.css('--bullet-duration', `${delay + speed}ms`)
				colorScheme(this)

				if (box.data('effect') === 'custom') {
					// Fix for first slide
					const firstSlide = this.slides[0]
					firstSlide.classList.remove('no-animation')

					// Fix autoplay for custom effect
					if (this.params.autoplay.waitForTransition === true) {
						this.params.autoplay.delay = delay + speed
						this.params.autoplay.waitForTransition = false
						this.autoplay.stop()
						this.autoplay.start()
					}
				}

				// Ensure videos in active slide start from the beginning
				const $activeSlide = $(this.slides[this.activeIndex])
				const video = $activeSlide.find('video').get(0)

				if (!video) return

				// Reset video to start and play
				video.currentTime = 0
				video.play()
			})

			function colorScheme(context) {
				//const parent = $(context.el).parent();
				const parent = box.find('.slideshow-bottom')
				const activeIndex = context.activeIndex
				const activeSlide = context.slides[activeIndex]
				const changeItems = [parent[0]]
				const colorScheme = $(activeSlide)
					.find('.slideshow-slide')
					.data('color-scheme')
				changeItems.forEach((item) => {
					if (!item) return ''
					const classes = item.classList
					for (let className of classes) {
						if (/color-background-\d+$/.test(className)) {
							item.classList.remove(className)
						}
					}
					item.classList.add(colorScheme)
				})
			}

			const resizeObserver = new ResizeObserver((entries) => {
				if (!isLive(section, state)) return;
				entries.forEach((entry) => {
					const style = window.getComputedStyle(entry.target.querySelector('.container'));
					const paddingLeft = parseFloat(style.paddingLeft);
					const paddingRight = parseFloat(style.paddingRight);
					const widthSlide = entry.contentRect.width - paddingLeft - paddingRight;
					entry.target.style.setProperty("--width-slide", `${widthSlide}px`);
				})
			})
			state.observers.push(resizeObserver);
			resizeObserver.observe(section);
		})
	}

	const disposeSection = (section, state) => {
		state.active = false;
		try {
			state.timers.forEach((timer) => clearTimeout(timer));
			state.timers.clear();
			state.observers.forEach((observer) => observer.disconnect());
			state.listeners.forEach(([node, event, callback]) => node.removeEventListener(event, callback));
			// Swiper attaches itself to its element before its init callbacks run.
			const swiper = state.swiper || state.swiperElement?.swiper;
			state.swiperListeners.forEach(([event, callback]) => swiper?.off(event, callback));
			if (swiper && !swiper.destroyed) swiper.destroy(true, true);
			if (state.split) state.split.revert();
			else if (state.headings?.length && typeof SplitType !== 'undefined') SplitType.revert(state.headings);
		} finally {
			section.querySelectorAll('.js-split-text, .js-fade').forEach((node) => node.classList.remove('visible'));
			section.classList.remove('slider_started');
			sections.delete(section);
		}
	};

	const initialise = (root = document) => {
		const targets = [...root.querySelectorAll('.slideshow-section')];
		if (root.matches?.('.slideshow-section')) targets.unshift(root);
		targets.forEach((section) => {
			if (sections.has(section) || !section.querySelector('.slideshow-swiper__slide')) return;
			const state = {
				active: true, timers: new Set(), observers: [], listeners: [], swiperListeners: [],
				swiperElement: section.querySelector('.slideshow__swiper'),
			};
			sections.set(section, state);
			try {
				slideshow(section, state);
				headingAnimation(section, state);
			} catch (error) {
				try {
					disposeSection(section, state);
				} catch (cleanupError) {
					throw new AggregateError([error, cleanupError], 'Slideshow initialisation and cleanup failed');
				}
				throw error;
			}
		});
	};

	const dispose = (root) => {
		sections.forEach((state, section) => {
			if (root.contains(section)) disposeSection(section, state);
		});
	};

	const initialiseDocument = () => {
		document.removeEventListener('DOMContentLoaded', initialiseDocument);
		window.removeEventListener('load', initialiseDocument);
		initialise();
	};
	document.addEventListener('shopify:section:load', (event) => initialise(event.target));
	document.addEventListener('shopify:section:unload', (event) => dispose(event.target));
	if (document.readyState === 'complete') {
		initialiseDocument();
	} else {
		// Defer can still be running while readyState is interactive; a later
		// section may supply SplitType. Load also covers a late editor asset.
		document.addEventListener('DOMContentLoaded', initialiseDocument);
		window.addEventListener('load', initialiseDocument);
	}
})()
